import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'

export const SkeletonAnimation = styled.div`
	background-position: left;
	background: ${colorTheme.tableV2.skeleton};
	background-size: 50%;
	animation: shine 0.7s linear infinite;

	@keyframes shine {
		to {
			background-position: right;
		}
	}
`
SkeletonAnimation.displayName = 'SkeletonAnimation'

export const Skeleton = styled(SkeletonAnimation)`
	width: 5.56em;
	height: 1.38em;
	border-radius: 0.93em;
`
Skeleton.displayName = 'Skeleton'
